import { useCurrentUser } from "../context/user/UserContext"

export default function useFindHelpLink() {
  const currentUser = useCurrentUser()
  const zip = currentUser?.zip
  const carrotFindHelpLink = "https://www.findhelp.org"
  const findHelpLink = zip ? `${carrotFindHelpLink}/search_results/${zip}` : carrotFindHelpLink
  return { findHelpLink }
}
